import React, { useEffect, useState } from "react";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';

import { AdminLayout } from "../../layouts"
import {
    Box, Button, Grid, IconButton
    , Paper, Typography, TextField, Dialog, DialogTitle,
    DialogContent, DialogContentText, DialogActions,
    Chip,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Menu
} from '@mui/material';

import {
    DataGrid,
    GridToolbar,
    GridRowsProp,
    GridColDef,
    GridFilterModel,
    GridColumnVisibilityModel,
    GridCellParams,

} from '@mui/x-data-grid';
import { MoreVert, People } from "@mui/icons-material";
import { deleteCurso, getCursosAdmin, postCurso, putCurso } from "../../api/providers";


import Cookies from "js-cookie";
import { LoadingScreen } from "../../ui/components/LoadingScreen";
import { useForm, Controller, set } from "react-hook-form";


export const CoursesPage = () => {

    const token: any = Cookies.get("token");

    const navigate = useNavigate();

    let location = useLocation();

    const RowMenu = (params: any) => {
        let paramsRow = params.rowIndex;

        const [anchorEl, setAnchorEl] = React.useState(null);
        const open = Boolean(anchorEl);

        const handleClick = (event: any) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

        return (
            <>
                <IconButton
                    aria-label="more"
                    id={`long-button-${paramsRow.id}`}
                    aria-controls={open ? 'long-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    onClick={handleClick}
                >
                    <MoreVert />
                </IconButton>
                <Menu
                    id={`long-menu-${paramsRow.id}`}
                    MenuListProps={{
                        'aria-labelledby': `long-button-${paramsRow.id}`,
                    }}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                >

                    <MenuItem onClick={() => handleOpenEditDialog(paramsRow)}>Editar Curso</MenuItem>
                    <MenuItem onClick={() => handleOpenDeleteDialog(paramsRow)}>Eliminar Curso</MenuItem>
                    <MenuItem onClick={() => handleVerInscritos(paramsRow.id)}>Ver estudiantes inscritos</MenuItem>


                </Menu>
            </>
        );
    };



    /* las tablas start */
    const columns: GridColDef[] = [

        // ACCIONES
        {
            field: 'acciones', headerName: '', width: 50,
            renderCell: (params) => <RowMenu rowIndex={params.row} />,
        },

        { field: 'nombre', headerName: 'Nombre', width: 300 },

        {
            field: 'precio',
            headerName: 'Precio',
            width: 120,
            renderCell: (params: GridCellParams) =>
                new Intl.NumberFormat('es-CR', {
                    style: 'currency',
                    currency: 'CRC'
                }).format(params.value as number),
        },
        {
            field: 'totalInscripciones',
            headerName: 'Estudiantes Inscritos',
            width: 160,
            type: 'number',
            headerAlign: 'left',
            align: 'left',
            renderCell: (params: GridCellParams) => {
                const inscritos = params.value as any;


                return (
                    <>
                        <Chip
                            label={inscritos} // Número de inscritos
                            sx={{

                                color: "#292929",
                                borderRadius: 1,
                                width: "50%", // Ajustar ancho del chip
                                fontWeight: "bold",
                                fontSize: "1rem", // Tamaño de fuente más pequeño
                                textAlign: "center",
                            }}
                        />
                        <IconButton
                            onClick={() => handleVerInscritos(params.row.id)}
                            color="primary"
                            aria-label="ver estudiantes"
                        >
                            <People />
                        </IconButton>
                    </>
                );
            },
        },

        {
            field: 'estado', headerName: 'Estado', headerAlign: "left", width: 120, type: 'string',

            renderCell: (params: GridCellParams) => (
                <Chip
                    label={params.value as string}
                    sx={{
                        backgroundColor: params.value === "activo" ? "#81C784" : // Verde para activo
                            params.value === "inactivo" ? "#C94A4A" : "grey", // Rojo para inactivo
                        color: "white", // Texto en blanco para mejor visibilidad
                        borderRadius: 1, // Bordes redondeados
                        width: "100%", // Ancho fijo
                        fontWeight: "bold", // Fuente en negrita
                        fontSize: "1rem", // Tamaño de fuente más pequeño
                    }} />),
        },

        //verificar si requiere requiereRetiroEnCorreos que es un boolean en la db
        {
            field: 'requiereRetiroEnCorreos',
            headerName: 'Requiere retirar libro',
            width: 200,
            headerAlign: "left",
            align: 'center',
            type: 'boolean',
            renderCell: (params: GridCellParams) => (
                <Chip
                    label={params.value === true ? "Sí" : "No"}
                    sx={{
                        backgroundColor: params.value === true ? "secondary.dark" : // Azul para Sí
                            "primary.light", // Rojo para No
                        color: "white", // Texto en blanco
                        borderRadius: 1, // Bordes redondeados
                        width: "60%", // Ancho fijo
                        fontWeight: "bold", // Fuente en negrita
                        fontSize: "1rem",
                    }}
                />
            ),
        },


    ];

    const [cursos, setCursos] = useState<any>([]);
    const [loading, setLoading] = useState<any>(true);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
        const token: any = Cookies.get("token");
        const fetchCursos = async () => {
            setLoading(true);
            const response = await getCursosAdmin(token);
            if (!response.ok) {
                setError('No se pudo cargar los cursos');
                setCursos([]);
            } else {

                setCursos(response.cursos.cursos);
            }
            setLoading(false);
        };

        fetchCursos();
    }, []);

    const rows: GridRowsProp = cursos

    const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
        items: [],
        quickFilterExcludeHiddenColumns: true,
        quickFilterValues: [''],
    });

    const [columnVisibilityModel, setColumnVisibilityModel] =
        React.useState<GridColumnVisibilityModel>({});

    /* las tablas end */


    /* para agregar y editar cursos start */

    // Formulario para agregar nuevos cursos
    const {
        register: registerAdd,
        handleSubmit: handleSubmitAdd,
        formState: { errors: errorsAdd },
        reset: resetAdd
    } = useForm({
        defaultValues: {
            nombre: '',
            precio: '',
            estado: '',
            setRequiereRetiroEnCorreos: '',
            requiereRetiroEnCorreos: false
        }
    });

    // Formulario para editar cursos existentes
    const {
        register: registerEdit,
        handleSubmit: handleSubmitEdit,
        formState: { errors: errorsEdit },
        reset: resetEdit,
        control, // Añadir control para usar Controller
        setValue, // Necesario para establecer el valor en el controlador
        watch
    } = useForm();

    const [openAddDialog, setOpenAddDialog] = useState(false);
    const [requiereRetiroEnCorreos, setRequiereRetiroEnCorreos] = useState("1");
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [editData, setEditData] = useState({});

    const handleOpenAddDialog = () => {
        setOpenAddDialog(true);
    };

    const handleCloseAddDialog = () => {
        setOpenAddDialog(false);
        resetAdd();
    };

    const handleOpenEditDialog = (row: any) => {
        setEditData(row);
        resetEdit(row); // Pre-carga los datos existentes en el formulario para editar
        setValue("estado", row.estado); // Establece el valor de `estado` al valor del curso
        setOpenEditDialog(true);
    };

    const handleCloseEditDialog = () => {
        setOpenEditDialog(false);
    };

    const handleSaveAdd = handleSubmitAdd(async (data) => {

        //convertir a booleano el valor de requiereRetiroEnCorreos
        data.requiereRetiroEnCorreos = requiereRetiroEnCorreos === '1' ? true : false;

        await postCurso(token, data);

        //resetear la tabla
        const response = await getCursosAdmin(token);
        if (!response.ok) {
            setError('No se pudo cargar los cursos');
            setCursos([]);
        } else {
            setCursos(response.cursos.cursos);
        }

        handleCloseAddDialog();


    });

    const handleSaveEdit = handleSubmitEdit(async (data) => {

        // Lógica para editar el curso aquí
        await putCurso(token, data);

        //resetear la tabla
        const response = await getCursosAdmin(token);
        if (!response.ok) {
            setError('No se pudo cargar los cursos');
            setCursos([]);
        } else {
            setCursos(response.cursos.cursos);
        }

        handleCloseEditDialog();
    });

    const handleVerInscritos = (id: any) => {
        navigate(`/admin/estudiantes-curso-grupo`, { state: { cursoId: id } });
    }

    /* para aagregar y editar datos end */


    /* para borrar datos start */
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const handleOpenDeleteDialog = (id: any) => {
        setDeleteId(id);
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
    };

    const handleDelete = async (id: any) => {
        // Lógica para eliminar el curso

        await deleteCurso(token, id);

        //resetear la tabla
        const response = await getCursosAdmin(token);
        if (!response.ok) {
            setError('No se pudo cargar los cursos');
            setCursos([]);
        } else {
            setCursos(response.cursos.cursos);
        }

        // Aquí añades la llamada a la API para eliminar el curso
        handleCloseDeleteDialog();
    };
    /* para borrar datos end  */




    return (

        <AdminLayout title='Cursos'>

            < >

                {loading ? <LoadingScreen /> :
                    error ? <div>Error: {error}</div>
                        : <Paper

                            sx={{ overflow: "hidden", width: "100%", borderRadius: 2, mt: 0, p: 2 }}
                        >
                            <Grid item xs={12} container alignItems="center" justifyContent="space-between" mb={1}>

                                <Box >
                                    <Typography
                                        fontSize={22} component="div" align="left" >
                                        Todos los cursos
                                    </Typography>
                                </Box>
                                <Button onClick={handleOpenAddDialog} variant="contained" color="primary">
                                    Agregar nuevo curso
                                </Button>

                            </Grid>

                            <Box sx={{ height: "85vh" }}>
                                <DataGrid
                                    columns={columns}
                                    rows={rows}
                                    sx={{ padding: "10px" }}
                                    slots={{ toolbar: GridToolbar }}
                                    filterModel={filterModel}
                                    onFilterModelChange={(newModel) => setFilterModel(newModel)}
                                    slotProps={{
                                        toolbar: {
                                            showQuickFilter: true,

                                        },
                                    }}
                                    columnVisibilityModel={columnVisibilityModel}
                                    onColumnVisibilityModelChange={(newModel) =>
                                        setColumnVisibilityModel(newModel)
                                    }
                                />

                            </Box>
                        </Paper>
                }

            </>





            {/* Dialog for Editing Existing Course */}
            <Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
                <form onSubmit={handleSaveEdit}>
                    <DialogTitle>Editar Curso</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="nombre"
                            label="Nombre del Curso"
                            type="text"
                            fullWidth

                            {...registerEdit("nombre", {
                                minLength: { value: 5, message: "El nombre debe tener al menos 5 caracteres" }
                            })}
                            error={Boolean(errorsEdit.nombre)}

                        />
                        <TextField
                            margin="dense"
                            id="precio"
                            label="Precio del Curso"
                            type="number"
                            fullWidth

                            {...registerEdit("precio", {
                                validate: value => +value > 0 || "El precio debe ser mayor que 0"
                            })}
                            error={Boolean(errorsEdit.precio)}

                        />

                        {/* select para seleccionar el estado, activo, inactivo o archivado */}
                        <FormControl fullWidth error={!!errorsEdit.estado} sx={{ mt: 1 }} variant="filled">
                            <InputLabel id="estado-label">Estado</InputLabel>
                            <Controller
                                name="estado"
                                control={control}
                                defaultValue=""
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        labelId="estado-label"
                                        id="estado-select"
                                        label="Estado"
                                        onChange={(e) => {
                                            field.onChange(e.target.value); // Asegura que el valor sea "archivado"
                                            setValue("estado", e.target.value); // Actualiza el estado en react-hook-form
                                        }}
                                    >
                                        <MenuItem value="activo">Activo</MenuItem>
                                        <MenuItem value="inactivo">Inactivo</MenuItem>
                                        <MenuItem value="archivado">Archivado</MenuItem>
                                    </Select>
                                )}
                            />
                            <FormHelperText>{errorsEdit.estado?.message}</FormHelperText>
                        </FormControl>


                        {/* Campo para seleccionar si requiere retiro en correos */}
                        <FormControl fullWidth variant="filled" sx={{ mt: 1 }}>
                            <InputLabel id="requiereRetiroEnCorreos-label">Requiere Retiro de Libro</InputLabel>
                            <Controller
                                name="requiereRetiroEnCorreos"
                                control={control}
                                defaultValue={editData.requiereRetiroEnCorreos ?? false}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        labelId="requiereRetiroEnCorreos-label"
                                        id="requiereRetiroEnCorreos"
                                    >
                                        <MenuItem value={true}>Sí</MenuItem>
                                        <MenuItem value={false}>No</MenuItem>
                                    </Select>
                                )}
                            />
                        </FormControl>


                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseEditDialog} color="error">Cancelar</Button>
                        <Button type="submit" color="primary">Guardar</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
                <DialogTitle>Confirmación</DialogTitle>
                <DialogContent>
                    <DialogContentText>¿Estás seguro de que quieres eliminar este curso?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDeleteDialog}>No</Button>
                    <Button onClick={() => handleDelete(deleteId)} color="error" autoFocus>Sí</Button>
                </DialogActions>
            </Dialog>

            {/* Dialog for Adding New Course */}
            <Dialog open={openAddDialog} onClose={handleCloseAddDialog}>
                <form onSubmit={handleSaveAdd}>
                    <DialogTitle>Agregar Nuevo Curso</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="nombre"
                            label="Nombre del Curso"
                            fullWidth
                            variant="outlined"
                            {...registerAdd("nombre", {
                                required: "El nombre es requerido",
                                minLength: {
                                    value: 5,
                                    message: "El nombre debe tener al menos 5 caracteres"
                                }
                            })}
                            error={Boolean(errorsAdd.nombre)}
                            helperText={errorsAdd.nombre?.message}
                        />
                        <TextField
                            margin="dense"
                            id="precio"
                            label="Precio del Curso"
                            type="number"
                            fullWidth
                            variant="outlined"
                            {...registerAdd("precio", {
                                required: "El precio es requerido",
                                validate: value => +value > 0 || "El precio debe ser mayor que 0"
                            })}
                            error={Boolean(errorsAdd.precio)}
                            helperText={errorsAdd.precio?.message}
                        />

                        {/* Campo para seleccionar si requiere retiro en correos */}
                        <FormControl fullWidth variant="filled" sx={{ mt: 1 }}>
                            <InputLabel id="requiereRetiroEnCorreos-label">Requiere Retiro de Libro</InputLabel>
                            <Controller
                                name="requiereRetiroEnCorreos"

                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        labelId="requiereRetiroEnCorreos-label"
                                        id="requiereRetiroEnCorreos"
                                        value={requiereRetiroEnCorreos} // Usa el estado de useState
                                        onChange={(e) => {
                                            setRequiereRetiroEnCorreos(e.target.value); // Actualiza el estado
                                            field.onChange(e.target.value); // Asegura que el valor también se pase al formulario
                                        }}
                                    >
                                        <MenuItem value="1">Sí</MenuItem>
                                        <MenuItem value="2">No</MenuItem>
                                    </Select>
                                )}
                            />
                        </FormControl>



                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseAddDialog} color="error">Cancelar</Button>
                        <Button type="submit" color="primary">Guardar</Button>
                    </DialogActions>
                </form>
            </Dialog>

        </AdminLayout >
    )
}
